import {
    INIT_APPLICATION,
    PROGRESS_REPORT,
    FINAL_REPORT,
    LOCAL_SAE_REPORT,
    SUSAR_REPORT,
    PROTOCOL_DEVIATION_REPORT,
    MISCELLANEOUS_REPORT,
    CTC,
    CTI,
    FULL_REVIEW,
    PHASE_1_REVIEW,
    EXPEDITED_REVIEW,
    AMENDMENT_FORM,
} from 'utility/postApprovalLookUp';
import { APPROVED, ACKNOWLEDGED, DISAPPROVED } from 'utility/lookup';

const useConsolidationData = () => {

    let listOfDecision = {
        [APPROVED]: { display: 'Approved', key: APPROVED },
        [ACKNOWLEDGED]: { display: 'Acknowledged', key: ACKNOWLEDGED },
        [DISAPPROVED]: { display: 'Disapproved', key: DISAPPROVED },
    };

    const decisionMapingList = {
        [INIT_APPLICATION]: {
            [FULL_REVIEW]: [APPROVED, DISAPPROVED],
            [PHASE_1_REVIEW]: [APPROVED, DISAPPROVED],
            [EXPEDITED_REVIEW]: [APPROVED],
        },
        [PROGRESS_REPORT]: {
            [FULL_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [PHASE_1_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [EXPEDITED_REVIEW]: [APPROVED, ACKNOWLEDGED],
        },
        [FINAL_REPORT]: {
            [FULL_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [PHASE_1_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [EXPEDITED_REVIEW]: [APPROVED, ACKNOWLEDGED],
        },
        [LOCAL_SAE_REPORT]: {
            [FULL_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [PHASE_1_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [EXPEDITED_REVIEW]: [APPROVED, ACKNOWLEDGED],
        },
        [SUSAR_REPORT]: {
            [FULL_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [PHASE_1_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [EXPEDITED_REVIEW]: [APPROVED, ACKNOWLEDGED],
        },
        [PROTOCOL_DEVIATION_REPORT]: {
            [FULL_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [PHASE_1_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [EXPEDITED_REVIEW]: [APPROVED, ACKNOWLEDGED],
        },
        [MISCELLANEOUS_REPORT]: {
            [FULL_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [PHASE_1_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [EXPEDITED_REVIEW]: [APPROVED, ACKNOWLEDGED],
        },
        [CTC]: {
            [FULL_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [PHASE_1_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [EXPEDITED_REVIEW]: [APPROVED, ACKNOWLEDGED],
        },
        [CTI]: {
            [FULL_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [PHASE_1_REVIEW]: [APPROVED, ACKNOWLEDGED, DISAPPROVED],
            [EXPEDITED_REVIEW]: [APPROVED, ACKNOWLEDGED],
        },
        [AMENDMENT_FORM]: {
            [FULL_REVIEW]: [APPROVED, DISAPPROVED],
            [PHASE_1_REVIEW]: [APPROVED, DISAPPROVED],
            [EXPEDITED_REVIEW]: [APPROVED],
        },
    };

    const getDecisionMapingList = ({ documentType, reviewType, isPostApproval, isViewOnly }) => {
        /** list all data when page is isViewOnly */
        if (isViewOnly) {
            const list = Object.keys(listOfDecision)?.map(key => {
                return listOfDecision[key];
            });
            return list;
        };

        if (decisionMapingList[documentType] && decisionMapingList[documentType][reviewType]) {
            let list = decisionMapingList[documentType][reviewType]?.map(item => {
                return listOfDecision[item];
            });

            /** for initial application, there is no acknowledge status decision */
            if (!isPostApproval) {
                list = list?.filter((item) => {
                    return item.key !== ACKNOWLEDGED;
                });
            };
            return list;
        };
        
        return [];
    };

    return {
        getDecisionMapingList,
    };
};
export default useConsolidationData;